import { render, staticRenderFns } from "./PatientId.vue?vue&type=template&id=c721e80c"
import script from "./PatientId.vue?vue&type=script&lang=js"
export * from "./PatientId.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports